<div class="full-width m-t-0-5">
	<mat-card class="p-0 primary-border h-100">
		<mat-card-content>
			<div fxLayout="column" fxLayoutGap="1rem">
				<div fxLayout="row" class="padding-0-5">
					<div
						fxFlex
						class="font-size-16 font-weight-bold primary-text"
						fxLayoutAlign="start center"
					>
						High Quality:
					</div>
					<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="end center">
						{{ qualityStats.high }}
					</div>
				</div>

				<div fxLayout="row" class="padding-0-5">
					<div
						fxFlex
						class="font-size-16 font-weight-bold primary-text"
						fxLayoutAlign="start center"
					>
						Medium Quality:
					</div>
					<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="end center">
						{{ qualityStats.medium }}
					</div>
				</div>

				<div fxLayout="row" class="padding-0-5">
					<div
						fxFlex
						class="font-size-16 font-weight-bold primary-text"
						fxLayoutAlign="start center"
					>
						Low Quality:
					</div>
					<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="end center">
						{{ qualityStats.low }}
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>
